<template>
	<div class="model_mid">
		<div class="mid_left">
			<h3>休眠期内环境监测及水肥灌溉情况</h3>
			<div class="mid_left_table_title">
				<div class="title_item" :class="{ title_item_active: activeIndex === 0 }" @click="addActive(0)">
					气象监测
				</div>
				<div class="title_item" :class="{ title_item_active: activeIndex === 1 }" @click="addActive(1)">
					土壤监测
				</div>
				<div class="title_item" :class="{ title_item_active: activeIndex === 2 }" @click="addActive(2)">
					水肥灌溉记录
				</div>
			</div>
			<wearth v-if="activeIndex===0" />
			<roil v-if="activeIndex===1" />
			<fertilizer v-if="activeIndex===2" />
		</div>
		<div class="mid_img">
			<img src="@/assets/period/1.png" alt="" />
		</div>
		<div class="mid_right">
			<div class="back_title"></div>
			<div class="agricultural_boder">
				<div class="agricultural">
					农事提醒：
				</div>
				<div class="agricultural_tcontent">
					<div class="agricultural_tcontent_left">
						冬季修剪：当年生苗按枝条直径 0.6cm 修剪， 剪去直径不足 0.6cm 的细弱枝。 2 年生以上的苗按不同架式采用直径大于 0.6
						cm的当年生枝，留一二个芽极短梢修剪，不足
						0.6cm 的枝条全部剪除； 主蔓上缺结果母枝时， 根据空缺节位多少， 采用多留邻枝芽或轻短截直径大于 0.8cm 的健壮邻枝，以牵拉绑引的方法填补，根据空间调整好树形。12
						月下旬至
						1 月中旬为最佳冬剪期， 最迟不超过 1 月下旬结束冬剪 ( 否则易出现伤流 )
					</div>
					<div class="agricultural_tcontent_mid">
						提醒时间：2024-12-21
					</div>
					<div class="agricultural_tcontent_right">
						已提醒
					</div>
				</div>
				<div class="divider"></div>
			</div>
			<div class="control">
				<p>
					<sapn class="diseases">主要病虫害:</sapn>
					<sapn class="diseases_text">越冬病虫（白腐病、炭疽病、黑痘病、蔓枯病、霜霉病、根癌病、根结线虫等、绿盲蝽、斑衣蜡蝉等），冻害、霜害、抽条、缺素症
					</sapn>
				</p>
				<p>
					<span class="Prevention">防治措施:</span>
					<span
						class="Prevention_text">清园（冬季修剪后把葡萄植株残体集中，并喷10%（质量分数，后同）尿素水后覆盖处理或将其粉碎，再喷2.5%的尿素水后旋耕处理），清园后可用5波美度石硫合剂喷枝条、水泥柱、水泥柱、铁丝等，防寒、埋土、培土、树干包扎、涂白、冬灌、剥树皮、刮斑衣蜡蝉卵块及介壳虫。

					</span>
				</p>
				<p>
					<span class="Prevention">有效积温:</span>
					<span class="Prevention_text"></span>
				</p>

			</div>

		</div>

	</div>
	<div class="model_content">
		<div class="model_content_title">休眠期</div>
		<div class="model_content_date">12-11 至 01-31</div>
		<div class="model_content_text">
			休眠期是阳光玫瑰葡萄的冬季阶段，此时植株处于静止状态，停止生长。根系活动也较少，这是为了避免寒冷天气对植株的损伤。这一时期，葡萄藤的枝条上没有叶子，显得光秃秃的。是进行修剪和准备来年生长的重要时期。
		</div>
	</div>

</template>

<script setup>
	import {
		ref
	} from 'vue';
	import wearth from './wearth/index.vue';
	import roil from './roil/index.vue';
	import fertilizer from './fertilizer/index.vue';

	let activeIndex = ref(0);

	function addActive(e) {
		activeIndex.value = e;
	}
</script>

<style lang="scss" scoped>
	.model_mid {
		width: 1840px;
		margin: 0 auto;
		height: 660px;
		background-image: url('../../../assets/model/mid-boder.png');
		background-size: 100% 100%;
		margin-top: 100px;
		display: flex;

		.mid_left {
			width: 660px;
			height: 540px;
			margin-top: 30px;
			margin-left: 30px;
			background-image: url("@/assets/model/mid-left.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			padding-top: 14px;

			h3 {
				margin-left: 40px;
				color: #2dffd0;
			}

			.mid_left_table_title {
				width: 60%;
				display: flex;
				font-size: 14px;
				margin: 0 auto;
				margin-top: 20px;
				justify-content: space-between;
				color: #00a580;

				.title_item {
					flex: 1;
					text-align: center;
					padding: 5px;
				}

				.title_item_active {
					background-image: url('@/assets/model/mid-left-button.png');
					color: white;
					background-size: 100% 100%;
				}
			}



		}

		.mid_img {
			margin-left: 30px;
			margin-top: 200px;
		}

		.mid_right {
			padding: 20px;
			width: 660px;
			height: 400px;
			margin-top: 30px;
			margin-left: 30px;
			background-image: url("@/assets/model/smallboder.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			padding-top: 14px;

			.back_title {
				height: 28px;
				width: 620px;
				background-image: url("@/assets/model/smalltitle.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}

			.agricultural_boder {
				font-size: 12px;

				.agricultural {
					color: #72a39f;
					margin-top: 20px;
					margin-left: 15px;
				}

				.agricultural_tcontent {
					width: 620px;
					display: flex;
					color: #007e62;
					margin-top: 10px;
					align-items: center;
					/* 垂直居中 */
					justify-content: space-between;
					/* 水平两端对齐 */
					padding-left: 15px;

					.agricultural_tcontent_left {
						text-align: justify;
						width: 350px;
					}

				}

				.divider {
					height: 2px;
					width: 100%;
					margin-top: 20px;
					background: linear-gradient(to right, transparent, #00796B, transparent);
				}
			}

			.control {
				color: white;
				margin-top: 20px;
				width: 100%;
				padding-left: 15px;
				text-align: justify;
				font-size: 14px;


				p {
					display: flex;
					justify-content: flex-start;
					padding-top: 15px;
				}

				.diseases {
					display: inline-block;
					width: 80px;
					color: #97cac8;
					text-align: right;

				}

				.diseases_text {
					display: inline-block;
					width: 520px;
					line-height: 20px;
					color: #007e62;
					padding-left: 20px;
				}

				.Prevention {
					display: inline-block;
					width: 80px;
					color: #97cac8;
					text-align: right;
				}

				.Prevention_text {
					display: inline-block;
					width: 520px;
					color: #007e62;
					line-height: 20px;
					padding-left: 20px;
				}



			}

		}

	}

	.model_content {
		width: 685px;
		height: 100px;
		margin: 0px auto;
		text-align: center;
		color: white;
		margin-top: -60px;

		.model_content_title {
			color: #23c9a4;
			font-size: 18px;
			font-weight: bold;
		}

		.model_content_date {
			margin-top: 10px;
			color: white;
			font-size: 16px;
			color: #23c9a4;
			font-weight: bold;
		}

		.model_content_text {
			margin-top: 10px;
			color: #23c9a4;
		}
	}
</style>